// Add-to-calendar helpers (Google Calendar link + .ics download for Apple/Outlook)

function getStartDate(tournament) {
  const d = tournament?.date;
  if (!d) return null;
  try {
    if (typeof d === 'string' && d.includes('T')) {
      const dt = new Date(d);
      return isNaN(dt.getTime()) ? null : dt;
    }
    const datePart = String(d).slice(0, 10);
    const time = tournament.start_time || '09:00';
    const dt = new Date(`${datePart}T${time}:00+03:00`); // Israel time
    return isNaN(dt.getTime()) ? null : dt;
  } catch {
    return null;
  }
}

function stamp(dt) {
  return dt.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
}

export function getCalendarEvent(tournament) {
  const start = getStartDate(tournament);
  if (!start) return null;
  const end = new Date(start.getTime() + 3 * 60 * 60 * 1000); // ברירת מחדל: 3 שעות
  const title = `🎾 ${tournament.name || 'תחרות טניס'}`;
  const location = tournament.location || tournament.club || 'Tennis Pro Israel';
  const details = `תחרות ${tournament.type === 'daily' ? 'יומית' : 'נוקאאוט'} · Tennis Pro Israel\nhttps://tennisproisrael.co.il`;
  return { start, end, title, location, details };
}

export function getGoogleCalendarUrl(tournament) {
  const ev = getCalendarEvent(tournament);
  if (!ev) return null;
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: ev.title,
    dates: `${stamp(ev.start)}/${stamp(ev.end)}`,
    details: ev.details,
    location: ev.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs(tournament) {
  const ev = getCalendarEvent(tournament);
  if (!ev) return;
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//TennisProIsrael//Tournaments//HE',
    'CALSCALE:GREGORIAN',
    'BEGIN:VEVENT',
    `UID:${tournament.id || Date.now()}@tennisproisrael`,
    `DTSTAMP:${stamp(new Date())}`,
    `DTSTART:${stamp(ev.start)}`,
    `DTEND:${stamp(ev.end)}`,
    `SUMMARY:${ev.title}`,
    `DESCRIPTION:${ev.details.replace(/\n/g, '\\n')}`,
    `LOCATION:${ev.location}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${(tournament.name || 'tournament').replace(/\s+/g, '-')}.ics`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
